import {useDispatch} from 'react-redux';
// eslint-disable-next-line no-restricted-imports
import {useSearchParams} from 'react-router-dom';

import {
  businessCaseApi,
  useCreateFullCorrectiveTaxDocumentMutation,
  useCreatePartialCorrectiveTaxDocumentMutation,
} from '@dms/api/sales';
import {businessCaseRoutes} from '@dms/routes';
import {handleApiError} from '@dms/shared';

import {composePath, useNavigate} from 'shared/web';

import {AccountingDocumentFormValues} from '../../../types';
import {getValidatedCheckoutSearchParams} from '../utils/getValidatedCheckoutSearchParams';
import {useGetCorrectiveTaxForBCDocumentBody} from './useGetCorrectiveTaxForBCDocumentBody';

export const useHandleSubmitCheckoutCorrectiveDocument = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [getRequestBody] = useGetCorrectiveTaxForBCDocumentBody();
  const [searchParams] = useSearchParams();

  const [createFullCorrectiveTaxDocument] = useCreateFullCorrectiveTaxDocumentMutation();
  const [createPartialCorrectiveTaxDocument] = useCreatePartialCorrectiveTaxDocumentMutation();

  const submitCorrectiveTaxDocument = async (formData: AccountingDocumentFormValues) => {
    const {businessCaseId, orderId, paymentId, type} =
      getValidatedCheckoutSearchParams(searchParams);
    const requestBody = getRequestBody(formData);

    const createDocumentMutation =
      type === 'full' ? createFullCorrectiveTaxDocument : createPartialCorrectiveTaxDocument;

    await createDocumentMutation({
      businessCaseId,
      orderId,
      paymentId,
      correctiveTaxDocumentRequestBody: requestBody,
    })
      .unwrap()
      .then(() => {
        dispatch(
          businessCaseApi.util.invalidateTags([
            {
              type: 'BusinessCaseActions',
              id: businessCaseId,
            },
            {type: 'BusinessCaseDetail', id: businessCaseId},
          ])
        );
        navigate(
          composePath(businessCaseRoutes.checkout, {
            params: {id: businessCaseId},
            queryParams: {
              CheckoutOrder: 'payment',
              createdCorrectiveDocumentType: type,
            },
          })
        );
      })
      .catch(handleApiError);
  };

  return [submitCorrectiveTaxDocument] as const;
};
